const ROUTES = {
  external: {
    europaTransitLookup: 'https://ec.europa.eu/taxation_customs/dds2/tra/transit_home.jsp?Lang=en&Expand=true&',
    lvGuarantee: 'https://itvs.vid.gov.lv/#itms:11;;',
    ltGuarantee: 'https://litarweb.lrmuitine.lt/taric/web/securitycalc_EN',
    plGuarantee: 'https://ext-isztar4.mf.gov.pl/taryfa_celna/CalculateComplex?lang=EN',
    eeGuarantee: 'https://apps.emta.ee/ite-tariff-public/#/taric/duty/calculate',
  },
  login: '/login',
  transit: '/transit',
  newTransit: '/new-transit',
  transitP5: '/transit-operation',
  transitP5Url: '/transit-operation/:transitId',
  newTransitP5: '/new-transit-p5',
  newEns: '/new-ens',
  ens: '/ens',
  ensUrl: '/ens/:transitId',
  transitOperation: 'transit-operations',
  transitAudit: 'transit-audit',
  news: 'news',
  newsPost: 'news/:postId',

  restrictions: '/restrictions',
  traders: '/traders',
  restriction: '/restriction',
  newRestriction: '/new-restriction',
  registration: '/register',

  customers: '/customers',
  customer: '/customer',
  newCustomer: '/new-customer',
  externalCustomer: '/external-customer',
  newExternalCustomer: '/external-customer',
}

export default ROUTES
